import React from 'react';
import PropTypes from 'prop-types';

import FormCategory from './form/formCategory';
import { useLocalizedStringsContext } from './context/LocalizedStringsContext';

const Dashboard = ({ categories, locale, history }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    DASHBOARD: { dashboardHeadingTitle, applicationDashboard }
  } = localizedStrings;

  return (
    <>
      <div style={{ backgroundColor: '#f5f6f7', paddingBottom: '3em' }}>
        <div className="container 85%">
          <div id="title" style={{ paddingTop: '2em' }}>
            <h2>{dashboardHeadingTitle}</h2>
            <br />
          </div>

          <div
            style={{
              border: '1px solid #e2e2e2',
              boxShadow: '0px 5px 5px #dedede'
            }}
          >
            <h4
              style={{
                width: '100%',
                padding: '10px 15px',
                backgroundColor: '#4B286D',
                color: '#ffffff'
              }}
            >
              {applicationDashboard}
            </h4>
            {categories.map(({ fields }, index) => {
              const key = `category${index}`;
              return (
                <FormCategory
                  key={key}
                  row={index}
                  category={fields}
                  locale={locale}
                  history={history}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

Dashboard.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.object
    })
  ).isRequired,
  locale: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export default Dashboard;
